import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faShoppingCart, faComments } from '@fortawesome/free-solid-svg-icons';

const PromoCMSoltec = () => {
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.3 });

  const fadeInUp = {
    hidden: { opacity: 0, y: 20 },
    visible: (i = 1) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.3,
        duration: 0.6,
        ease: 'easeOut',
      },
    }),
  };

  return (
    <Box
      ref={ref}
      sx={{
        px: { xs: 3, md: 6 },
        py: 10,
        textAlign: 'center',
        backgroundColor: '#fff',
      }}
    >
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        viewport={{ once: true }}
      >
        <Button
          href="/categorias"
          variant="contained"
          startIcon={<FontAwesomeIcon icon={faShoppingCart} />}
          sx={{
            bgcolor: '#ff6700',
            color: '#fff',
            fontWeight: 'bold',
            borderRadius: '30px',
            px: 4,
            py: 1.5,
            fontSize: '1rem',
            textTransform: 'none',
            mb: 6,
            transition: 'all 0.3s ease',
            boxShadow: '0 4px 15px rgba(0, 0, 0, 0.2)',
            '&:hover': {
              transform: 'translateY(-3px)',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.25)',
              bgcolor: '#e65100',
            },
          }}
        >
          Explora todos los productos
        </Button>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.9, y: 20 }}
        whileInView={{ opacity: 1, scale: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <Typography
          variant="h2"
          sx={{
            fontWeight: 500,
            fontSize: { xs: '1.3rem', md: '1.8rem' },
            color: '#000',
            mt: 1,
          }}
        >
          Tecnología, soluciones y servicios a tu alcance
        </Typography>
      </motion.div>

      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={fadeInUp}
        custom={2}
      >
        <Typography
          variant="h3"
          sx={{
            mt: 4,
            mx: 'auto',
            maxWidth: '700px',
            fontSize: { xs: '1rem', sm: '1.1rem', md: '1.2rem' },
            color: '#444',
            lineHeight: 1.7,
          }}
        >
          En <strong>CMSOLTEC</strong> encontrarás repuestos, accesorios, pantallas, cargadores y todo lo que necesitas para tu laptop o PC. 
          También brindamos <strong>servicios técnicos especializados</strong> en mantenimiento y <strong>recuperación de datos</strong>. 
          Escríbenos y recibe atención personalizada por parte de nuestro equipo. Estamos listos para ayudarte con soluciones confiables y profesionales.
        </Typography>
      </motion.div>

      <motion.div
        initial={{ opacity: 0, scale: 0.95 }}
        whileInView={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, delay: 1 }}
        viewport={{ once: true }}
      >
        <Box mt={5}>
          <Button
            component="a"
            href="https://api.whatsapp.com/send?phone=593984813777&text=Hola%2C%20quiero%20más%20información%20sobre%20sus%20productos%20y%20servicios%20en%20ASH%20TECH"
            target="_blank"
            rel="noopener noreferrer"
            startIcon={<FontAwesomeIcon icon={faComments} />}
            sx={{
              bgcolor: '#666666', 
              color: '#ffffff',    
              fontWeight: 'bold',
              fontSize: '1rem',
              px: 5,
              py: 1.5,
              borderRadius: '50px',
              textTransform: 'none',
              transition: 'all 0.3s ease',
              '&:hover': {
                bgcolor: '#4d4d4d', 
                transform: 'scale(1.05)',
                boxShadow: '0px 6px 18px rgba(100, 100, 100, 0.3)',
              },
            }}
          >
            Contáctanos por WhatsApp
          </Button>
        </Box>
      </motion.div>
    </Box>
  );
};

export default PromoCMSoltec;
